const MAX_DOCUMENT_LINKS = 100;

const isSafeDocumentUrl = (value) => {
    if (typeof value !== 'string' || !/^https?:\/\//i.test(value.trim())) return false;
    try {
        const url = new URL(value.trim());
        return ['http:', 'https:'].includes(url.protocol) && Boolean(url.hostname) && !url.username && !url.password;
    } catch {
        return false;
    }
};

const validateDocumentLinks = (links) => {
    if (!Array.isArray(links)) return 'Document links must be a list.';
    if (links.length > MAX_DOCUMENT_LINKS) return `Add up to ${MAX_DOCUMENT_LINKS} document links per supplier.`;
    for (let index = 0; index < links.length; index += 1) {
        const link = links[index];
        if (!link || typeof link.name !== 'string' || !link.name.trim() || link.name.trim().length > 200) {
            return `Link ${index + 1}: enter a name (up to 200 characters).`;
        }
        if (typeof link.url !== 'string' || link.url.trim().length > 4096 || !isSafeDocumentUrl(link.url)) {
            return `Link ${index + 1}: enter a valid http:// or https:// URL without a username or password.`;
        }
    }
    return true;
};

const normalizeDocumentLinks = (links) => links.map(({ name, url }) => ({ name: name.trim(), url: url.trim() }));

module.exports = { MAX_DOCUMENT_LINKS, isSafeDocumentUrl, validateDocumentLinks, normalizeDocumentLinks };
